import { Link } from 'react-router-dom';
import {
    getCollaboratorProfileHref,
    getInitials,
    getProfileLinkLabel,
} from '../../../vacations.definitions';

interface ApprovalCardHeaderProps {
    name: string;
    subtitle: string;
    collaboratorId?: string | null;
}

export function ApprovalCardHeader({ name, subtitle, collaboratorId }: ApprovalCardHeaderProps) {
    const profileHref = collaboratorId ? getCollaboratorProfileHref(collaboratorId) : null;

    return (
        <header className="flex items-start gap-3">
            {profileHref ? (
                <Link
                    to={profileHref}
                    aria-label={getProfileLinkLabel(name)}
                    className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary-100 text-sm font-bold text-primary-700 transition-colors hover:bg-primary-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500 font-montserrat"
                >
                    {getInitials(name)}
                </Link>
            ) : (
                <span
                    className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary-100 text-sm font-bold text-primary-700 font-montserrat"
                    aria-hidden="true"
                >
                    {getInitials(name)}
                </span>
            )}

            <div className="min-w-0 flex-1">
                <h3 className="truncate text-sm font-semibold text-raro-gray-900 font-montserrat">
                    {profileHref ? (
                        <Link
                            to={profileHref}
                            className="rounded transition-colors hover:text-primary-700 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500"
                        >
                            {name}
                        </Link>
                    ) : (
                        name
                    )}
                </h3>
                <p className="truncate text-xs text-raro-gray-500 font-montserrat">{subtitle}</p>
            </div>
        </header>
    );
}
